import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import ContactContainer from 'flow/components/contact-card/ContactContainers';
import { ExtensionKey } from 'flow/types/EntityKeys';
import { routes } from 'flow/types/routes';
import { generatePath } from 'flow/utils/router-utils';

interface Params {
    id: string;
    extensionKey: ExtensionKey;
}

// Each contact route in Messages and the calendar route next to it.
const CALENDAR_ROUTES: Record<string, string> = {
    [routes['messages.id.contact.key']]:
        routes['messages.id.contact.key.calendar'],
    [routes['messages.id.members.contact.key']]:
        routes['messages.id.members.contact.key.calendar'],
    [routes['messages.id.settings.members.contact.key']]:
        routes['messages.id.settings.members.contact.key.calendar'],
    [routes['messages.id.settings.contact.key']]:
        routes['messages.id.settings.contact.key.calendar'],
};

const ChatSessionContact: React.FC = () => {
    const { path, params } = useRouteMatch<Params>();
    const calendarRoute = CALENDAR_ROUTES[path];

    return (
        <ContactContainer
            parentExtensionKey={params.extensionKey}
            calendarPath={
                calendarRoute ? generatePath(calendarRoute, params) : undefined
            }
        />
    );
};

export default ChatSessionContact;
